import { render, staticRenderFns } from "./FiltroGraficoFazendaItem.vue?vue&type=template&id=afe636a6&scoped=true"
import script from "./FiltroGraficoFazendaItem.vue?vue&type=script&lang=js"
export * from "./FiltroGraficoFazendaItem.vue?vue&type=script&lang=js"
import style0 from "./FiltroGraficoFazendaItem.vue?vue&type=style&index=0&id=afe636a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe636a6",
  null
  
)

export default component.exports